import http from "@/http-common";
import filehttp from "@/http-file-common";

class S3FileMangeService {
    getS3File(data: any): Promise<any> {
        if (data.fileName.split(".")[1] == "pdf" || data.fileName.split(".")[1] == "PDF") {
            return http.api.post("/getS3File/", data);
        }
        return filehttp.api.post("/getS3File/", data);
    }
}

export default new S3FileMangeService();
